import { render, staticRenderFns } from "./KnowledgeBase.vue?vue&type=template&id=3273e99e&scoped=true&"
import script from "./KnowledgeBase.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBase.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBase.vue?vue&type=style&index=0&id=3273e99e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3273e99e",
  null
  
)

export default component.exports